<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="rule-view">
                        <p>在所绑定的玩家中，有部分玩家满足特殊条件，在活动期间内累计消费的5%，将以绑定梦三币的形式作为返点返还给邀请者（团长）</p>
                        <div class="img">
                            <img :src="require('@/assets/images/modal/rule-img.png')" alt="" srcset="">
                        </div>
                        <p>返利绑定梦三币将于活动结束后的7个工作日，统一发放至对应的游戏账号，请及时刷新可获得的返利金额，防止数据延迟。</p>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){
    .dialog-view{
        z-index: 100;
    }

    .rule-modal{
        width: 700px;
        height: 580px;
        background-image: url(~@/assets/images/modal/bg-modal-rule.png);        
    }

    .title{
        width: 524px;
        height: 51px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/modal/title-rule.png);  
    }

    .rule-view{
        padding: 0 54px;
        font-size: 21px;
        color: #4b4846;

        p{
            margin-bottom: 20px;
        }

        .img{
            margin-bottom: 20px;
            text-align: center;
        }
    }


    .u-btn.ok{
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);               
        width: 207px;
        height: 55px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);  
    }        

}


@media screen and (min-width: 1000px){
    @include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
    @include boxStyle( 1000 );
}   
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
        }
    },  
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/RuleModal/Modal.vue